import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Layout, Input, Button } from "antd";
import appActions from "@iso/redux/app/actions";
import TopbarUser from "./TopbarUser";
import TopbarWrapper from "./Topbar.styles";
import TopbarSearch from "./TopbarSearch";
import IntlMessages from "@iso/components/utility/intlMessages";
import { profileService } from "@iso/services";
import { pushnotification } from "../../services/pushnotification.service";
import { SearchOutlined, CloseCircleOutlined } from "@ant-design/icons";
import Notification from "./Notification";
import Setting from "./Setting";
import Hamburger from "./Hamburger";
import ListNotification from "./ListNotification";
import { useHistory } from "react-router";
import SharingMapModal from "./SharingMapModal";
import SARModal from "./SARModal";
import SAR from "./SAR";
import FormIcon from "./FormIcon";
import FormModal from "./FormModal";
import queryString from "query-string";
import AgencyStyleWrapper from "@iso/containers/Pages/Agency/Agency.styles";
import ContactAgentModal from "@iso/containers/Pages/Agency/ContactAgentModal";
import authAction from '@iso/redux/auth/actions';

const { logout } = authAction;

const { Header } = Layout;
const { toggleCollapsed, toggleChangeText, changeCurrent } = appActions;
const { Search } = Input;
const URL =
  process.env.REACT_APP_WEB_SOCKET_PROTOCOL +
  process.env.REACT_APP_WEB_SOCKET_URL;

export default function Topbar() {
  const history = useHistory();
  const customizedTheme = useSelector(
    (state) => state.ThemeSwitcher.topbarTheme
  );
  const activePropertyId = useSelector(
    (state) => state.property.activePropertyId
  );
  const activeAgent = useSelector((state) => state.property.agent);
  const [selectedItem, setSelectedItem] = React.useState("");
  const textTopbar = useSelector((state) => state.App.textTopBar);
  const { collapsed, openDrawer } = useSelector((state) => state.App);
  const [profileData, setProfileData] = React.useState({});
  const [modalSAROpen, setModalSAROpen] = React.useState(false);
  const currentUser = useSelector((state) => state.user.user);
  const [isShowSharingMapModal, setIsShowSharingMapModal] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [dataNotification, setDataNotification] = useState([]);
  const [readyState, setReadySate] = useState();
  const [searchInput, setsearchInput] = React.useState('');
  const [ws, setWs] = useState();
  const [isShowFormModal, setIsShowFormModal] = useState(false);
  const [isShowContactAgentModal, setIsShowContactAgentModal] = useState(false);
  const agentLogo =
    activeAgent && activeAgent.logos
      ? activeAgent.logos[activeAgent.logos.length - 1]
      : null;
  const [toggleNoti, setToggleNoti] = useState(false);
  const isMobileScreen = window.innerWidth < 768;
  const dispatch = useDispatch();

  const handleToggle = React.useCallback(() => {
    dispatch(toggleCollapsed());
    dispatch(toggleChangeText());
  }, [dispatch]);

  const getDataNotification = useCallback(() => {
    if (!activePropertyId || !currentUser?.id) return;

    pushnotification.getData(activePropertyId).then((res) => {
      if (res.code === "0000") {
        setDataNotification(res.notification || []);
        const unread = (res.notification || []).filter(n => !n.is_read).length;
        setUnreadCount(unread);
      }
    });
  }, [activePropertyId, currentUser?.id]);

  useEffect(() => {
    setWs(new WebSocket(URL));
  }, []);

  const isCollapsed = collapsed && !openDrawer;
  const styling = {
    background: customizedTheme.backgroundColor,
    position: "fixed",
    height: 70,
  };

  // Profile: fetch once when user is available (profile is user-level, not property-level)
  useEffect(() => {
    if (currentUser) {
      updateProfileData();
    }
  }, [currentUser]);

  // Notifications: fetch on property change
  useEffect(() => {
    if (activePropertyId && currentUser?.id) {
      pushnotification.getData(activePropertyId).then((res) => {
        if (res.code === "0000") {
          setDataNotification(res.notification || []);
          const unread = (res.notification || []).filter(n => !n.is_read).length;
          setUnreadCount(unread);
        }
      });
    }
  }, [activePropertyId, currentUser?.id]);

  useEffect(() => {
    if (ws) {
      ws.onopen = function (e) {
        console.log("webSocket connected");
      };

      ws.onmessage = (e) => {
        if (e.data) {
          getDataNotification();
        }
      };

      return () => {
        ws.onclose = () => {
          console.log("WebSocket Disconnected");
          setWs(new WebSocket(URL));
        };
      };
    }
  }, [ws, getDataNotification]);

  const updateProfileData = () => {
    profileService.getProfile().then((res) => {
      if (res.code === "0000") {
        setProfileData(res.user);
      }
    })
      .catch(err => {
        console.log('Logout because of error: ', err);
        dispatch(logout());
      });
  };

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      history.push("/search?s=" + e.target.value);
    }
  };

  const showFormModal = () => {
    setIsShowFormModal(true);
  };

  const cancelFormModal = () => {
    setIsShowFormModal(false);
  };

  const showContactAgentModal = () => {
    setIsShowContactAgentModal(true);
  };

  const cancelContactAgentModal = () => {
    setIsShowContactAgentModal(false);
  };

  const handleCancelSearch = () => {
    setsearchInput('')
    history.goBack();
    dispatch(changeCurrent(['dashboard']));
  }

  return (
    <AgencyStyleWrapper>
      <TopbarWrapper>
        {currentUser.is_public_view_user && agentLogo ? (
          <img className="agent-logo" src={agentLogo.full_path} height="40" />
        ) : (
          <></>
        )}
        <Header
          style={styling}
          className={`menuTop ${isCollapsed ? "isomorphicTopbar collapsed" : "isomorphicTopbar"
            }`}
        >
          <div className="isoLeft">
            {isMobileScreen && (
              <button
                className={
                  isCollapsed
                    ? "triggerBtn menuCollapsed"
                    : "triggerBtn menuOpen"
                }
                style={{ color: customizedTheme.textColor }}
                onClick={handleToggle}
              />
            )}
            <Input
              placeholder="Search…"
              size="large"
              className="search-bar"
              value={searchInput}
              onChange={(e) => setsearchInput(e.target.value)}
              onKeyDown={handleSearch}
              prefix={
                !searchInput ? (
                  <>
                    <SearchOutlined className="site-form-item-icon" />
                  </>
                ) : (
                  <CloseCircleOutlined
                    onClick={handleCancelSearch}
                    className="site-form-item-cancel"
                  />
                )
              }
            />

          </div>

          <ul className="isoRight">
            {window.location.pathname === "/share-map" && activeAgent ? (
              <li>
                <Button
                  id="btn-contact-agent"
                  type="primary"
                  onClick={showContactAgentModal}
                >
                  <IntlMessages id="topbar.contactAgent" />
                </Button>
              </li>
            ) : (
              <>
                <li onClick={() => setModalSAROpen(true)}>
                  <SAR />
                </li>
                <li className="head-bar-notificication">
                  <Notification
                    setToggleNoti={setToggleNoti}
                    toggleNoti={toggleNoti}
                    unreadCount={unreadCount}
                  />
                  {toggleNoti && (
                    <ListNotification
                      getDataNotification={getDataNotification}
                      dataNotification={dataNotification}
                      currentUser={currentUser}
                    />
                  )}
                </li>
                <li onClick={showFormModal}>
                  <FormIcon />
                </li>
              </>
            )}
            <li onClick={() => setSelectedItem("user")} className="isoUser">
              <TopbarUser />
            </li>
            <li className="isoUserName" title="View your profile">
              {/* Full navigation to /profile, matching the "My profile"
                  dropdown link (a plain <a href>), rather than SPA push. */}
              <a href="/profile" style={{ color: "inherit" }}>
                {profileData.name
                  ? String(profileData.name).trim().split(/\s+/)[0]
                  : ""}
              </a>
            </li>
          </ul>
        </Header>
        <FormModal
          isShowFormModal={isShowFormModal}
          cancelFormModal={cancelFormModal}
        />
        <SARModal modalSAROpen={modalSAROpen} setModalSAROpen={setModalSAROpen} />
        <ContactAgentModal
          isShowContactAgentModal={isShowContactAgentModal}
          cancelModal={cancelContactAgentModal}
        />
      </TopbarWrapper>
    </AgencyStyleWrapper>
  );
}